import template from './lease-assignment-checkbox.jade';

export default angular
  .module('cian.addForm.leaseAssignmentCheckbox', [])
  .directive('cianAfPriceAndDealTermsLeaseAssignmentCheckbox', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller() {
      this.ad.bargainTerms = this.ad.bargainTerms || {};
      this.ad.bargainTerms.contractType = this.ad.bargainTerms.contractType || 'sale';
    },
    controllerAs: 'leaseAssignmentCheckbox',
    template,
  })).name;
